// Copyright (c) 2018 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {getUseAmount, getUseAmountUpdated} from '../../services/get-use-amount';
import {FormattedMessage} from 'react-intl';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';

const LatestPerUnitMeasurements = props =>
    <div className='latest-per-unit-measurements'>
        <div className='data-label'>
            <FormattedMessage id='PREVIOUS_AMOUNT_OF_USE'/>
        </div>
        {props.latestPerUnitMeasurements.map(measurement =>

            <div
                className='use-amount'
                key={measurement.documentNumber}
            >
                {getUseAmount(measurement)} <span className='updated'>{getUseAmountUpdated(measurement)}</span>

            </div>

        )}
    </div>;

LatestPerUnitMeasurements.displayName = 'LatestPerUnitMeasurements';
LatestPerUnitMeasurements.propTypes = {
    latestPerUnitMeasurements: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired
};

export default LatestPerUnitMeasurements;



// WEBPACK FOOTER //
// ./src/shared/components/latest-per-unit-measurements/index.js